import React, { useContext } from 'react';
import 'twin.macro';
import { useNavigate } from 'react-router-dom';
import { PreferenceContext, CommentsContext } from '../context';
import { TitleRow } from '../text';
import { Button } from '../button';
import { useDataLoader } from '../common/hooks';
import { getItemDetails } from 'services/dumpert';
import { moderateArticle } from 'services/comments';
import { settings } from '../../settings';
import { AddCommentButton } from './';

export const ModeratorButtons = ({ itemId }) => {
  const {
    preference: {
      sorting: { comments: commentsSort },
    },
  } = useContext(PreferenceContext);
  const navigate = useNavigate();
  const { commentsList } = useContext(CommentsContext);
  const lastCommentId =
    Math.max(
      ...commentsList.flatMap((x) => [x.id, ...(x.child_comments?.map((y) => y.id) || [])]),
    ) || 0;

  const loadItemDetails = useDataLoader(getItemDetails);
  const { result: itemResult } = loadItemDetails({ itemId });
  const { ADMIN_HOST_URL } = settings;
  const uploadId = itemResult ? itemResult.data.items[0].upload_id : undefined;
  const toAdminURL = `${ADMIN_HOST_URL}/edit/${uploadId}`;

  return (
    <TitleRow tw='!top-12 bg-opacity-90 z-10' sticky>
      <div tw='flex w-full justify-center gap-2 items-center'>
        <a href={toAdminURL} target='_blank' rel='noopener noreferrer'>
          <Button tw='m-0' label='admin' danger />
        </a>
        <AddCommentButton tw='mb-0' />
        {commentsSort === 'Moderator view' && (
          <Button
            label='goedkeuren'
            info
            onClick={() => moderateArticle({ commentId: lastCommentId }).then(() => navigate(0))}
          />
        )}
      </div>
    </TitleRow>
  );
};
